
import { DaButtonGroup, DaButton, DaFlag } from '@daiso/design-system'
import { commonfunc } from '~/mixin/common'

export default {
  components: {
    DaButtonGroup,
    DaButton,
    DaFlag
  },
  mixins: [commonfunc],
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    selectedIndex: {
      type: [String, Number],
      default: null
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    ppupType: {
      type: String,
      default: ''
    },
    posiStrInfoList: {
      type: Array,
      default: () => {
        return []
      }
    },
    posiQuickStrInfoList: {
      type: Array,
      default: () => {
        return []
      }
    },
    purchaseValue: {
      type: String,
      default: '01'
    },
    recentDvya: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isMbc: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      rqstMtr: [],
    }
  },
  created () {
  },
  async mounted () {
    const grpList = ['CD_00162']
    this.cmmnCdList = await this.selCmmnCd(grpList)
    this.rqstMtr = this.cmmnCdFilter(this.cmmnCdList, 'CD_00162', '', '')
  },
  methods: {
    updAddr (item) {
      this.$emit('upd-addr', item)
    },
    delAddr (item) {
      this.$emit('del-addr', item)
    },
    selAddr (item) {
      this.$emit('sel-addr', item)
    },
    isRecentDvya (item) {
      if (String(item.dvyaSeq) === this.recentDvya?.orAddr?.dvyaSeq) {
        return true
      } else {
        return false
      }
    },
    isPossiMass (item) {
      if (this.posiStrInfoList.length > 0) {
        const zipCnt = this.posiStrInfoList.filter((i) => { return item.addrZip === i.zip }).length
        if (zipCnt > 0) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    isPossiQuick (item) {
      if (this.posiQuickStrInfoList.length > 0) {
        const zipCnt = this.posiQuickStrInfoList.filter((i) => { return item.addrZip === i.zip }).length
        if (zipCnt > 0) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    getCmmnCdNm (rqstTy) {
      const rqstMtrList = this.rqstMtr.find(item => item.cmmnCd === rqstTy)
      return rqstMtrList ? rqstMtrList.cmmnCdNm : ''
    }
  }
}
